export const Settings04Icon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.33301 6.66675L13.333 6.66675M13.333 6.66675C13.333 8.04746 14.4523 9.16675 15.833 9.16675C17.2137 9.16675 18.333 8.04746 18.333 6.66675C18.333 5.28604 17.2137 4.16675 15.833 4.16675C14.4523 4.16675 13.333 5.28604 13.333 6.66675ZM8.33301 13.3334L18.333 13.3334M8.33301 13.3334C8.33301 14.7141 7.21372 15.8334 5.83301 15.8334C4.4523 15.8334 3.33301 14.7141 3.33301 13.3334C3.33301 11.9527 4.4523 10.8334 5.83301 10.8334C7.21372 10.8334 8.33301 11.9527 8.33301 13.3334Z"
      stroke="#8746EC"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={pathClassName}
    />
  </svg>
);
